export function gpcEnabled(): boolean {
  if (typeof navigator === "undefined") return false;
  return Boolean(navigator.globalPrivacyControl);
}

export function dntEnabled(): boolean {
  if (typeof navigator !== "undefined") {
    const n = navigator as Navigator & {
      doNotTrack?: string;
      msDoNotTrack?: string;
    };
    if (n.doNotTrack === "1") return true;
    if (n.msDoNotTrack === "1") return true;
  }
  if (typeof window !== "undefined") {
    const w = window as Window & { doNotTrack?: string };
    if (w.doNotTrack === "1") return true;
  }
  return false;
}

/**
 * Stub. TODO(post-Phase-1): fetch /v1/sites/<pid>/policy and cache. Until that
 * endpoint ships, GPC enforcement is server-side. We attach `Sec-GPC: 1` on
 * every send when the browser signal is set; the collector decides whether
 * to drop or downgrade.
 */
export function loadPolicy(pixelId: string): unknown | null {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(`fs_policy_${pixelId}`);
    return raw ? (JSON.parse(raw) as unknown) : null;
  } catch {
    return null;
  }
}
